import { createSlice } from "@reduxjs/toolkit";
import { getUsers, getUser, searchUsers, createUser, getAlerts, addNote, updateUser, initialClinic, deleteUser } from "../../api/APIServices";
import { API_STATUS } from "../../constants";
import { dynamicSort } from "../../utils/utils";

    const initialState = {
        status:API_STATUS.IDEL,
        userAlertStatus:API_STATUS.IDEL,
        users:[],
        isFilter: false,
        filteredUsers:[], 
    };
    
    const usersSlice = createSlice({
        name:'users',
        initialState,
        reducers:{
        sort(state, action){
            const {data, sortField, isAsc, element} = action.payload
            const sortedData = dynamicSort(data, sortField, isAsc);
            if(action.payload.element === 'users') {
                state.users = sortedData;
            }
        },
       
        resetFilter(state){
            state.filteredUsers = [];
            state.isFilter = false;
        },
       
    },
    extraReducers:(builder)=>{

         //getUsers
        builder.addCase(getUsers.fulfilled, (state, action)=>{
            state.users = action.payload;
            state.status = API_STATUS.IDEL;
        }),
        builder.addCase(getUsers.pending, (state)=>{
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(getUsers.rejected, (state)=>{
            state.status = API_STATUS.ERROR;
        }),

        //searchUsers
        builder.addCase(searchUsers.fulfilled, (state, action)=>{
            state.filteredUsers = action.payload.result;
            state.status = API_STATUS.IDEL;
            state.isFilter = action.payload?.isFilter ? action.payload?.isFilter : false;
        }),
        builder.addCase(searchUsers.pending, (state)=>{
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(searchUsers.rejected, (state)=>{
            state.status = API_STATUS.ERROR;
        }),
        
        // createUser
        builder.addCase(createUser.fulfilled, (state, action)=>{
            state.users.push(action.payload);
            state.status = API_STATUS.IDEL;           
        }),
        builder.addCase(createUser.pending, (state)=>{
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(createUser.rejected, (state)=>{
            state.status = API_STATUS.ERROR;
        }),

       // delete User
        builder.addCase(deleteUser.fulfilled, (state, action)=>{
            state.status = API_STATUS.SUCCESS;  
            state.isUserDeleted = true         
        }),
        builder.addCase(deleteUser.pending, (state)=>{
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(deleteUser.rejected, (state)=>{
            state.status = API_STATUS.ERROR;
        }),
        
        //Alerts
        builder.addCase(getAlerts.fulfilled, (state, action)=>{
            state.userAlerts = action.payload;
            state.userAlertStatus = API_STATUS.SUCCESS;
        }),
        builder.addCase(getAlerts.pending, (state)=>{
            state.userAlertStatus = API_STATUS.PENDING;
        }),
        builder.addCase(getAlerts.rejected, (state)=>{
            state.userAlertStatus = API_STATUS.ERROR;
        })

  
    }
});

export const {sort,
    resetFilter, 
} = usersSlice.actions;
export default usersSlice.reducer;